import { Datepicker as DP, DISABLED_DATES } from '@code/innovance-react-ui-kit';

import { FormatFunction } from 'i18next';
import React, { FC, useCallback } from 'react';
import { useLanguageState } from 'src/front/contexts/I18nContext';
import { useUserInfoState } from 'src/front/contexts/SessionContext';

export declare type FirstDayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

interface DatePickerProps {
  value: Date | null;
  autoScroll?: boolean;
  errorMessage?: string;
  inputLabel?: string;
  minimumYear?: number;
  onChange?(date: Date | null): void;
  disabled?: boolean;
  disabledDates?: DISABLED_DATES;
  displayFormat?: string | FormatFunction;
  firstDayOfWeek?: FirstDayOfWeek;
  numberOfMonths?: number;
  rangeYear?: { past: number; future: number };
}

const Datepicker: FC<DatePickerProps> = ({
  value,
  autoScroll = true,
  errorMessage,
  inputLabel,
  minimumYear = 1900,
  onChange,
  disabled = false,
  displayFormat,
  disabledDates = DISABLED_DATES.AFTER_TODAY,
  firstDayOfWeek,
  numberOfMonths,
  rangeYear,
}) => {
  const language = useLanguageState();
  const { processDate } = useUserInfoState();
  const formatWeekdayLabels = useCallback(
    (label: Date) => label.toLocaleString(language, { weekday: 'short' }),
    [language]
  );

  return (
    <DP
      autoScroll={autoScroll}
      disabled={disabled}
      disabledDates={disabledDates}
      displayFormat={displayFormat}
      errorMessage={errorMessage}
      firstDayOfWeek={firstDayOfWeek}
      initialSelectedDate={processDate}
      inputLabel={inputLabel}
      minimumYear={minimumYear}
      monthLocale={language}
      numberOfMonths={numberOfMonths}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onChange={onChange || (() => {})}
      rangeYear={rangeYear}
      value={value}
      weekdayLabelFormat={formatWeekdayLabels}
    />
  );
};

export default Datepicker;
